





















import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ISubcontractorListRequest, IUser } from "@/types/user";
import { IPagination } from "@/types";
import { ISiteListRequest } from "@/types/site";
import Search from "@/components/admin/forms/Search.vue";

@Component({
  components: {
    Search
  }
})
export default class extends Vue {
  @Action("user/adminGetList")
  public adminGetList!: (request: ISubcontractorListRequest) => boolean;

  @Action("site/adminGetList")
  public getSiteList!: (params: ISiteListRequest) => boolean;

  @Getter("user/subcontractorList")
  public userList!: IUser[];

  @Getter("user/pagination")
  public pagination!: IPagination<IUser>;

  @Watch("$route.query")
  public async changeQuery() {
    this.queryToParams();
    await this.adminGetList(this.params);
  }

  @Mutation("user/clear")
  public clear!: () => void;

  // @Prop({ default: 0 })
  // public fixed_site_id!: number;

  //
  // variables
  //
  public site_id = 0;

  public headers = [
    { text: "現場名", value: "subcontractor_site.name", sortable: false },
    { text: "顧客名", value: "name", sortable: false },
    { text: "フリガナ", value: "kana", sortable: true },
    { text: "下請けID", value: "login_id", sortable: false }
  ];
  public params: ISubcontractorListRequest = {
    site_id: 0,
    search: "",
    page: 1,
    per_page: 50,
    is_subcontractor: true
  };

  //
  // methods
  //
  private async created() {
    // this.site_id = Number(this.$route.params.site_id);
    // this.params.site_id = this.site_id;
    this.clear();
    this.getSiteList(this.params);
    this.queryToParams();
    this.adminGetList(this.params);

    // if (!this.fixed_site_id) {
    //   this.headers.push({
    //     text: "現場名",
    //     value: "site.name",
    //     sortable: false
    //   });
    // }
  }

  // urlからパラメータをセットする
  // $router -> params
  private queryToParams() {
    const query = this.$route.query;
    this.params = {
      // site_id: this.fixed_site_id || 0,
      search: query.search ? decodeURI(query.search as string) : "",
      page: query.page ? Number(query.page) : 1,
      per_page: query.per_page ? Number(query.per_page) : 50,
      is_subcontractor: query.is_subcontractor
        ? Boolean(query.is_subcontractor)
        : true
    };
  }

  // 1ページ目から検索
  // 主に検索条件が変更されたときに利用
  public async searchFirst() {
    this.params.page = 1;
    await this.paramsToQuery();
  }

  // URLのパラメータをセットする
  // params -> $router
  private paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          site_id: this.params.site_id ? String(this.params.site_id) : "",
          search: this.params.search,
          page: this.params.page ? String(this.params.page) : "1"
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  public rowClick(user: IUser) {
    this.$router.push(`/admin/setting/subcontractor/${user.id}/edit`);
  }
}
